import { useTranslation } from "react-i18next";
import sleepCoachSlide1 from "@assets/images/sleepCoachSlide1.png";
import sleepCoachSlide2 from "@assets/images/sleepCoachSlide2.png";
import sleepCoachSlide3 from "@assets/images/sleepCoachSlide3.png";
import mindfulnessSlide1 from "@assets/images/mindfullnessStep1.png";
import mindfulnessSlide2 from "@assets/images/mindfulnessStep2.png";
import mindfulnessSlide3 from "@assets/images/mindfulnessStep3.png";
import quizGameSlide1 from "@assets/images/quizGameSlide1.png";
import quizGameSlide2 from "@assets/images/quizGameSlide2.png";
import quizGameSlide3 from "@assets/images/quizGameSlide3.png";
import motivationSlide1 from "@assets/images/motivationSlide1.png";
import motivationSlide2 from "@assets/images/motivationSlide2.png";
import motivationSlide3 from "@assets/images/motivationSlide3.png";

export const useLoaderSlides = (type = "sleep") => {
  const { t } = useTranslation();

  const dataMap = {
    sleep: [
      {
        src: sleepCoachSlide1,
        key: "1",
        heading: t("SleepCoachLoader.slides.0.heading"),
        subheading: t("SleepCoachLoader.slides.0.subheading"),
        description: t("SleepCoachLoader.slides.0.description"),
        analyzingPlan: t("SleepCoachLoader.slides.0.analyzingPlan"),
      },
      {
        src: sleepCoachSlide2,
        key: "2",
        heading: t("SleepCoachLoader.slides.1.heading"),
        subheading: t("SleepCoachLoader.slides.1.subheading"),
        description: t("SleepCoachLoader.slides.1.description"),
        analyzingPlan: t("SleepCoachLoader.slides.1.analyzingPlan"),
      },
      {
        src: sleepCoachSlide3,
        key: "3",
        heading: t("SleepCoachLoader.slides.2.heading"),
        subheading: t("SleepCoachLoader.slides.2.subheading"),
        description: t("SleepCoachLoader.slides.2.description"),
        analyzingPlan: t("SleepCoachLoader.slides.2.analyzingPlan"),
      },
    ],
    mindfulness: [
      {
        src: mindfulnessSlide1,
        key: "1",
        heading: t("mindfulnessLoader.slides.0.heading"),
        subheading: t("mindfulnessLoader.slides.0.subheading"),
        description: t("mindfulnessLoader.slides.0.description"),
        analyzingPlan: t("mindfulnessLoader.slides.0.analyzingPlan"),
      },
      {
        src: mindfulnessSlide2,
        key: "2",
        heading: t("mindfulnessLoader.slides.1.heading"),
        subheading: t("mindfulnessLoader.slides.1.subheading"),
        description: t("mindfulnessLoader.slides.1.description"),
        analyzingPlan: t("mindfulnessLoader.slides.1.analyzingPlan"),
      },
      {
        src: mindfulnessSlide3,
        key: "3",
        heading: t("mindfulnessLoader.slides.2.heading"),
        subheading: t("mindfulnessLoader.slides.2.subheading"),
        description: t("mindfulnessLoader.slides.2.description"),
        analyzingPlan: t("mindfulnessLoader.slides.2.analyzingPlan"),
      },
    ],
    quizGame: [
      {
        src: quizGameSlide1,
        key: "1",
        heading: t("quizGameLoader.slides.0.heading"),
        subheading: t("quizGameLoader.slides.0.subheading"),
        description: t("quizGameLoader.slides.0.description"),
        analyzingPlan: t("quizGameLoader.slides.0.analyzingPlan"),
      },
      {
        src: quizGameSlide2,
        key: "2",
        heading: t("quizGameLoader.slides.1.heading"),
        subheading: t("quizGameLoader.slides.1.subheading"),
        description: t("quizGameLoader.slides.1.description"),
        analyzingPlan: t("quizGameLoader.slides.1.analyzingPlan"),
      },
      {
        src: quizGameSlide3,
        key: "3",
        heading: t("quizGameLoader.slides.2.heading"),
        subheading: t("quizGameLoader.slides.2.subheading"),
        description: t("quizGameLoader.slides.2.description"),
        analyzingPlan: t("quizGameLoader.slides.2.analyzingPlan"),
      },
    ],
    motivation: [
      {
        src: motivationSlide1,
        key: "1",
        heading: t("motivationLoader.slides.0.heading"),
        subheading: t("motivationLoader.slides.0.subheading"),
        description: t("motivationLoader.slides.0.description"),
        analyzingPlan: t("motivationLoader.slides.0.analyzingPlan"),
      },
      {
        src: motivationSlide2,
        key: "2",
        heading: t("motivationLoader.slides.1.heading"),
        subheading: t("motivationLoader.slides.1.subheading"),
        description: t("motivationLoader.slides.1.description"),
        analyzingPlan: t("motivationLoader.slides.1.analyzingPlan"),
      },
      {
        src: motivationSlide3,
        key: "3",
        heading: t("motivationLoader.slides.2.heading"),
        subheading: t("motivationLoader.slides.2.subheading"),
        description: t("motivationLoader.slides.2.description"),
        analyzingPlan: t("motivationLoader.slides.2.analyzingPlan"),
      },
    ],
  };

  return dataMap[type] || [];
};
